var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "w-full",
      attrs: {
        target: "_blank",
        href:
          "https://www.google.com/maps?q=" +
          _vm.address +
          "+(" +
          _vm.lat +
          "," +
          _vm.lng +
          ")"
      }
    },
    [
      _c("img", {
        staticClass: "w-full h-[400px] object-cover",
        attrs: {
          src:
            "https://maps.googleapis.com/maps/api/staticmap?center=" +
            _vm.lat +
            "," +
            _vm.lng +
            "&scale=2&maptype=roadmap&markers=color:red%7C" +
            _vm.lat +
            "," +
            _vm.lng +
            "&zoom=16&size=1600x888&key=" +
            _vm.key +
            "&style=feature%3Aall%7Celement%3Aall%7Csaturation%3A-100"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }